import React from 'react';
import { MainLayout, Triptych } from '@app/components';
import { TaxList, TaxCard, TaxUpdate } from '@app/features/Tax';
import { useResourceScreenHelpers } from '@app/hooks';
import { taxApi } from '@app/store';
import { ITax } from '@app/common';
import { SettingHeader } from '@app/features/SettingHeader';

export const TaxScreen = () => {
  const [readOne, { isFetching }] = taxApi.useLazyReadOneTaxQuery();

  const { triptych, onUpdate, selectedItem, item: tax } = useResourceScreenHelpers<ITax>();

  const openCard = (item: Partial<ITax>) => {
    onUpdate(readOne({
      filters: { _id: { $eq: item?._id } },
    }), item);
  }

  return (
    <MainLayout header={<SettingHeader />}>

      <Triptych
        list={(
          <TaxList
            selectedRowItem={selectedItem}
            onRowPress={(item) => triptych.close({ data: item, mode: 'UPDATE' })}
            onUpdate={openCard} />
        )}
        card={(
          <TaxCard
            tax={tax ?? selectedItem}
            toggle={(mode) => mode === 'UPDATE' ? openCard(selectedItem) : triptych.toggle()} />
        )}
        form={(
          <TaxUpdate
            tax={tax}
            isFetching={isFetching} />
        )} />
    </MainLayout >
  );
};

